module.exports = __webpack_public_path__ + "static/media/Border_2.0168197d.jpg";